// extracted by mini-css-extract-plugin
module.exports = {"locationListTable":"locations_locationListTable__1JLoW","status":"locations_status__3zbFP"};